<script setup>
const props = defineProps({
  data: Object,
  pulseData: Object
})
const emailData = toRef(props, 'pulseData');
const { getRecShared } = useLeadGenRecData();
const { data: recSharedData } = await getRecShared();
const emit = defineEmits('validateStep');
const selectedEmail = ref(null);
const placeholderText = props.data.sharedContent ? recSharedData.value.data.attributes.emailFields?.emailPlaceholderText : props.data.placeholderText;
const errorText = props.data.sharedContent ? recSharedData.value.data.attributes.emailFields?.emailErrorMessage : props.data.errorText;
const invalidEmailText = props.data.sharedContent ? recSharedData.value.data.attributes.emailFields?.invalidEmailErrorMessage : props.data.invalidEmailText;
const zeroBounceValidation = props.data.sharedContent ? recSharedData.value.data.attributes.emailFields?.zeroBounceValidation : props.data.zeroBounceValidation;

const onDataChanged = (emailAddress) => {
  handleEmailChange();
  selectedEmail.value = emailAddress.value;
  emailData.value.emailAddress = selectedEmail.value;
  emit('validateStep', {
  value: selectedEmail.value,
  component: props.data.component
});
}

const handleEmailChange = () => {
  const emailInput = document.querySelector('#course-rec-email input[type="email"]');  
  if (emailInput) {
    emailInput.classList.remove('is-invalid');
    const placeholderLabel = document.querySelector('#course-rec-email .placeholder-label');
    const errorLabel = document.querySelector('#course-rec-email .error-label');
    if (placeholderLabel && errorLabel) {
      placeholderLabel.classList.replace('d-none', 'd-block');
      errorLabel.classList.replace('d-block', 'd-none');
    }
  }
};

const onKeyPressFunc = (emailAddress) => {
  selectedEmail.value = emailAddress.value;
  emailData.value.emailAddress = selectedEmail.value;
  emit('validateStep', {
    value: selectedEmail.value,
    component: props.data.component
  });
}

onMounted(() => {
  const parentElement = document.getElementById('course-rec-email').parentElement.parentElement.parentElement
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
  value: selectedEmail.value,
  component: props.data.component
});
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <form id="course-rec-email" @submit.prevent :class="zeroBounceValidation ? 'z-validation' : ''">
    <fieldset>
      <div class="col mx-3">
        <FormFloatingLabelInput 
          :id="'email'" 
          :placeholderText="placeholderText" 
          :errorText="errorText" 
          :required="true"
          :type="'email'"           
          @onChanged="onDataChanged" 
          @onKeyPress="onKeyPressFunc" 
        />
      </div>
    </fieldset>
  </form>
</template>

<style lang="scss">
#course-rec-email {
  .form-floating {
    @include media-breakpoint-up(sm) {
      width: 350px;
      margin: 0 auto;;
    }
  }
}
</style>
